// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_searchItemGame__AD4bH {
    width: 100%;
    max-width: 100%;
    height: 48px;
    padding: 0 16px;
    color: white;
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid #fff;
    border-radius: 20px;
    outline: none;
    transition: all 0.3s ease;
}

.style_searchItemGame__AD4bH::placeholder {
    color: #fff;
    opacity: 1;
}

.style_searchItemGame__AD4bH:focus {
    background-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    border: 1px solid #fff !important;
}

.style_loadTime__Oa-L3 {
    font-size: 18px;
    margin-top: -30px;
    margin-bottom: 15px;
}

.style_detailGameInner__dD71e {
    background-image: url("https://trumcasino6789.com/images/sdsdsdsd1.png");
    background-repeat: no-repeat;
    background-size: 100% 100% !important;
    background-position: center;
    height: 590px;
    border-radius: unset !important;
    border: 1px solid #00FF84 !important;
    padding: 40px !important;
    background-color: unset !important;
    /* max-width: 1100px; */
    display: flex;
}

.style_avtartTable__P-3kn {
    width: 280px;
    background-size: 100% 100% !important;
}

.style_marquee-container__WBPrx {
    overflow: hidden;
    white-space: nowrap;
}

.style_containerDetail__T9oiO {
    padding: 20px 20px 20px 20px;
}

.style_imgTitleTable__ueW69 {
    height: 90px !important;
    width: 90px !important;
}

.style_marqueeContainer__tre6N {
    width: 400px;
    overflow: hidden;
    position: relative;
    height: 90px;
    border: 1px solid transparent;
}

.style_marqueeContent__T0-rz {
    position: absolute;
    white-space: nowrap;
    animation: style_marquee__fP-fD 30s linear infinite;
    color: white;
    font-size: 40px;
    font-weight: bold;
    left: 100%;
    transform: translateX(0);
}

@keyframes style_marquee__fP-fD {
    0% {
        left: 100;
        transform: translateX(0);
    }

    100% {
        left: 0;
        transform: translateX(-100%);
    }
}


.style_timeTable__KxlqK {
    position: relative;
    background-repeat: no-repeat;
    background-position: left center;
    width: 550px;
    height: 40px;
    margin-top: 40px;
    background-size: contain;
}

.style_fontCountdown__sfhBz {
    background: linear-gradient(180deg, rgba(146, 228, 76, 1) 26%, rgba(77, 221, 78, 1) 74%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    position: absolute;
    white-space: nowrap;
    font-weight: bold;
}

.style_fontStatusCountdown__GJkCW {
    left: 24px;
    top: -30%;
    transform: translateY(-50%);
    font-size: 25px;
}

.style_fontCountdown__sfhBz:not(.style_fontStatusCountdown__GJkCW) {
    left: 100%;
    font-size: 60px;
    margin-left: -340px;
    top: -15%;
    transform: translateY(-50%);
}


/* Vòng tròn xoay */
.style_circularCountdown__LTMGu {
    position: absolute;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-repeat: no-repeat;
    animation: style_spin__slbjp 3s linear infinite;
    width: 110px;
    height: 110px;
    top: -60%;
    left: 93%;
}

@keyframes style_spin__slbjp {
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

.style_btnShowTimeRound__m2FLv {
    margin-left: 15px;
    color: white;
    padding: 10px 12px;
    font-size: 20px;
    border-radius: 8px;
    font-weight: bold;
    background: #38E31B;
    cursor: pointer;
    background: linear-gradient(180deg, rgba(56, 227, 27, 1) 0%, rgba(22, 80, 30, 1) 100%);
}

.style_showPercentage__NeLLp {
    font-size: 50px;
    font-weight: bold;
    color: #22d94f;
}

.style_ShowTimeRound__IcAVg {
    font-weight: bold;
    color: #38E31B;
    text-align: center;
    font-size: 23px;
    line-height: 1;
}

.style_ShowTimeRound__IcAVg div:nth-child(2) {
    color: #fff;
    font-size: 25px;
}

/* cây dữ liệu */

.style_progressBar__le1KQ {
    height: 10px;
    width: 300px;
    position: absolute;
    left: 96px;
    border-radius: 5px;
    background-color: rgb(99 99 99 / 30%);
    overflow: hidden;
}

.style_progressStatusRed__EaDbD {
    background:
        repeating-linear-gradient(45deg,
            #ff3939,
            #ff3939 10px,
            #ffffff 10px,
            #ffffff 20px);
    animation:
        style_smooth-progress-red__RrLt8 3s linear infinite,
        style_roll-effect__-EqzW 1.5s linear infinite;
}

.style_progressStatusGreen__GZtyC {
    background:
        repeating-linear-gradient(45deg,
            darkgreen,
            darkgreen 10px,
            #ffffff 10px,
            #ffffff 20px);
    animation:
        style_smooth-progress-green__Rnm2h 3s ease-in infinite,
        style_roll-effect__-EqzW 1.5s linear infinite;
}

.style_progressStatusViolet__0OU2B {
    background:
        repeating-linear-gradient(45deg,
            violet,
            violet 10px,
            #ffffff 10px,
            #ffffff 20px);
    animation:
        style_smooth-progress-violet__xtIXb 3s ease-in infinite,
        style_roll-effect__-EqzW 1.5s linear infinite;
}

.style_progressStatusCadetblue__pBbU8 {
    background:
        repeating-linear-gradient(45deg,
            cadetblue,
            cadetblue 10px,
            #ffffff 10px,
            #ffffff 20px);
    animation:
        style_smooth-progress-cadetblue__M3A6k 3s ease-in infinite,
        style_roll-effect__-EqzW 1.5s linear infinite;

}


.style_progressStatus__oMM\\+I {
    position: relative;
    height: 100%;
    width: 0;
    border-radius: 5px;
    background-size: 200% 100%;
}

.style_progressStatus__oMM\\+I::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background: linear-gradient(90deg,
            rgba(0, 0, 0, 0.8) 0%,
            rgba(0, 0, 0, 0.4) 50%,
            transparent 100%);
    pointer-events: none;
}

@keyframes style_roll-effect__-EqzW {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -28px 0;
    }
}

/* Thanh đỏ: 25% → 100% → 0% → lặp */
@keyframes style_smooth-progress-red__RrLt8 {
    0% {
        width: 25%;
    }

    50% {
        width: 100%;
    }

    80% {
        width: 0%;
    }

    100% {
        width: 25%;
    }
}

/* Thanh xanh lá: 75% → 100% → 0% → lặp */
@keyframes style_smooth-progress-green__Rnm2h {
    0% {
        width: 75%;
    }

    40% {
        width: 100%;
    }

    70% {
        width: 0%;
    }

    100% {
        width: 75%;
    }
}

/* Thanh tím: 50% → 100% → 0% → lặp */
@keyframes style_smooth-progress-violet__xtIXb {
    0% {
        width: 50%;
    }

    60% {
        width: 100%;
    }

    90% {
        width: 0%;
    }

    100% {
        width: 50%;
    }
}

/* Thanh cadetblue: 0% → 100% → 0% → lặp */
@keyframes style_smooth-progress-cadetblue__M3A6k {
    0% {
        width: 0%;
    }

    30% {
        width: 100%;
    }

    60% {
        width: 0%;
    }

    100% {
        width: 0%;
    }
}

/* model hiển thị dữ liệu */

.style_modelConfirm__orEHM {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.808);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.style_dialogContent__fJxqV {
    text-align: center;
    background-color: rgba(24, 65, 26, 0.5);
    box-shadow: rgb(34, 217, 79) 0px 0px 10px 0px inset, rgb(34, 217, 79) 0px 0px 10px 0px;
    max-width: 800px;
    max-height: 600px;
    width: 100%;
    z-index: 2;
    border-width: 3px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-image: initial;
    border-radius: 50px;
    padding: 60px 35px 75px;
    font-weight: bold;
}

.style_dialogTitle__MzNOK {
    color: #fff;
    font-size: 50px;
    font-weight: bold;
    margin-bottom: 20px;
}

.style_dialogTime__8XV6f {
    background: linear-gradient(180deg, rgba(175, 232, 76, 1) 0%, rgba(54, 219, 79, 1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-size: 40px;
    margin-bottom: 15px;
    font-weight: bold;
}

.style_dialogBullets__EUt6F {
    color: #fff;
    font-size: 24px;
    margin-bottom: 25px;
}

.style_dialogCloseBtn__g0k28 {
    background: #38E31B;
    background: linear-gradient(180deg, rgba(175, 232, 76, 1) 0%, rgba(54, 219, 79, 1) 100%);
    color: #fff;
    font-weight: 700;
    border: 1px solid rgb(255, 255, 255);
    padding: 5px 50px;
    border-radius: 30px;
    font-size: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
}

@keyframes style_fadeIn__MBOhU {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}


@media screen and (max-width: 900px) {
    .style_responsiveDesktop__rIkj- {
        display: none !important;
    }
}

@media screen and (min-width: 900px) {
    .style_responsiveMobile__HQ0-w {
        display: none !important;
    }
}


.style_detailMobileGameInner__23wIo {
    background-image: url('https://trumcasino6789.com/images/KA_2.png');
    height: 500px;
    background-repeat: no-repeat;
    background-size: cover;
    display: block;
    margin: 0 auto;
    border: 1px solid rgb(0, 255, 132) !important;
    border-radius: 0 !important;
    width: 80%;
    max-width: 900px;
    min-width: 300px;
    box-sizing: border-box;
    overflow: hidden;
}

.style_titleMb__toeD1 {
    background-image: url('https://trumcasino6789.com/images/222.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: grid;
    height: 55px;
    max-width: 100%;
    /* width: 400px; */
    margin: 50px auto;
    place-content: center;
    margin: 5% 20px 5px 20px;
    color: #00FF84;
    font-size: calc(0.75rem + 1vw);
}

.style_imgavtarMobile__nq4yC {
    background-image: url('https://trumcasino6789.com/images/Vector-Smart-Object.png');
    background-repeat: no-repeat;
    background-size: cover;
    width: 110px;
    padding: 15px 15px;
}

.style_imgavtarMobile__nq4yC>img {
    width: 90px;
    height: 80px;
    border-radius: 10px;
}

/* styles.module.css */
.style_ratoteTimeMb__QOkSC {
    position: relative;
}

.style_circularContainerMb__qDdll {
    position: relative;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.style_rotatingBackground__Bv1EJ {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    animation: style_spinMb__Hfo-a 2s linear infinite;
}

.style_percentageText__lr62o {
    position: relative;
    font-size: 22px;
    font-weight: bold;
    color: white;
    z-index: 1;
}

@keyframes style_spinMb__Hfo-a {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/NH/style.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,0CAA0C;IAC1C,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;IAI7C,iCAAiC;AAHrC;;AAMA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wEAAwE;IACxE,4BAA4B;IAC5B,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,+BAA+B;IAC/B,oCAAoC;IACpC,wBAAwB;IACxB,kCAAkC;IAClC,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mDAAsC;IACtC,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,SAAS;QACT,wBAAwB;IAC5B;;IAEA;QACI,OAAO;QACP,4BAA4B;IAChC;AACJ;;;AAGA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,wFAAwF;IACxF,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;;AAGA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;IACxB,4BAA4B;IAC5B,+CAAkC;IAClC,YAAY;IACZ,aAAa;IACb,SAAS;IACT,SAAS;AACb;;AAEA;IACI;QACI,6CAA6C;IACjD;;IAEA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,sFAAsF;AAC1F;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,gBAAgB;;AAEhB;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI;;;;;yBAKqB;IACrB;;qDAEoC;AACxC;;AAEA;IACI;;;;;yBAKqB;IACrB;;qDAEoC;AACxC;;AAEA;IACI;;;;;yBAKqB;IACrB;;qDAEoC;AACxC;;AAEA;IACI;;;;;yBAKqB;IACrB;;qDAEoC;;AAExC;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ;;;6BAGyB;IACzB,oBAAoB;AACxB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,qCAAqC;AACrC;IACI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA,2BAA2B;;AAE3B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,sFAAsF;IACtF,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wFAAwF;IACxF,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,wFAAwF;IACxF,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;;AAGA;IACI,mEAAmE;IACnE,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,6CAA6C;IAC7C,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kEAAkE;IAClE,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;IACxB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,kFAAkF;IAClF,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,iDAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".searchItemGame {\n    width: 100%;\n    max-width: 100%;\n    height: 48px;\n    padding: 0 16px;\n    color: white;\n    background-color: rgba(255, 255, 255, 0.2);\n    border: 1px solid #fff;\n    border-radius: 20px;\n    outline: none;\n    transition: all 0.3s ease;\n}\n\n.searchItemGame::placeholder {\n    color: #fff;\n    opacity: 1;\n}\n\n.searchItemGame:focus {\n    background-color: rgba(255, 255, 255, 0.3);\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);\n}\n\n.searchItemGame:focus {\n    border: 1px solid #fff !important;\n}\n\n.loadTime {\n    font-size: 18px;\n    margin-top: -30px;\n    margin-bottom: 15px;\n}\n\n.detailGameInner {\n    background-image: url(\"https://trumcasino6789.com/images/sdsdsdsd1.png\");\n    background-repeat: no-repeat;\n    background-size: 100% 100% !important;\n    background-position: center;\n    height: 590px;\n    border-radius: unset !important;\n    border: 1px solid #00FF84 !important;\n    padding: 40px !important;\n    background-color: unset !important;\n    /* max-width: 1100px; */\n    display: flex;\n}\n\n.avtartTable {\n    width: 280px;\n    background-size: 100% 100% !important;\n}\n\n.marquee-container {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.containerDetail {\n    padding: 20px 20px 20px 20px;\n}\n\n.imgTitleTable {\n    height: 90px !important;\n    width: 90px !important;\n}\n\n.marqueeContainer {\n    width: 400px;\n    overflow: hidden;\n    position: relative;\n    height: 90px;\n    border: 1px solid transparent;\n}\n\n.marqueeContent {\n    position: absolute;\n    white-space: nowrap;\n    animation: marquee 30s linear infinite;\n    color: white;\n    font-size: 40px;\n    font-weight: bold;\n    left: 100%;\n    transform: translateX(0);\n}\n\n@keyframes marquee {\n    0% {\n        left: 100;\n        transform: translateX(0);\n    }\n\n    100% {\n        left: 0;\n        transform: translateX(-100%);\n    }\n}\n\n\n.timeTable {\n    position: relative;\n    background-repeat: no-repeat;\n    background-position: left center;\n    width: 550px;\n    height: 40px;\n    margin-top: 40px;\n    background-size: contain;\n}\n\n.fontCountdown {\n    background: linear-gradient(180deg, rgba(146, 228, 76, 1) 26%, rgba(77, 221, 78, 1) 74%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    position: absolute;\n    white-space: nowrap;\n    font-weight: bold;\n}\n\n.fontStatusCountdown {\n    left: 24px;\n    top: -30%;\n    transform: translateY(-50%);\n    font-size: 25px;\n}\n\n.fontCountdown:not(.fontStatusCountdown) {\n    left: 100%;\n    font-size: 60px;\n    margin-left: -340px;\n    top: -15%;\n    transform: translateY(-50%);\n}\n\n\n/* Vòng tròn xoay */\n.circularCountdown {\n    position: absolute;\n    transform: translate(-50%, -50%);\n    background-size: contain;\n    background-repeat: no-repeat;\n    animation: spin 3s linear infinite;\n    width: 110px;\n    height: 110px;\n    top: -60%;\n    left: 93%;\n}\n\n@keyframes spin {\n    from {\n        transform: translate(-50%, -50%) rotate(0deg);\n    }\n\n    to {\n        transform: translate(-50%, -50%) rotate(360deg);\n    }\n}\n\n.btnShowTimeRound {\n    margin-left: 15px;\n    color: white;\n    padding: 10px 12px;\n    font-size: 20px;\n    border-radius: 8px;\n    font-weight: bold;\n    background: #38E31B;\n    cursor: pointer;\n    background: linear-gradient(180deg, rgba(56, 227, 27, 1) 0%, rgba(22, 80, 30, 1) 100%);\n}\n\n.showPercentage {\n    font-size: 50px;\n    font-weight: bold;\n    color: #22d94f;\n}\n\n.ShowTimeRound {\n    font-weight: bold;\n    color: #38E31B;\n    text-align: center;\n    font-size: 23px;\n    line-height: 1;\n}\n\n.ShowTimeRound div:nth-child(2) {\n    color: #fff;\n    font-size: 25px;\n}\n\n/* cây dữ liệu */\n\n.progressBar {\n    height: 10px;\n    width: 300px;\n    position: absolute;\n    left: 96px;\n    border-radius: 5px;\n    background-color: rgb(99 99 99 / 30%);\n    overflow: hidden;\n}\n\n.progressStatusRed {\n    background:\n        repeating-linear-gradient(45deg,\n            #ff3939,\n            #ff3939 10px,\n            #ffffff 10px,\n            #ffffff 20px);\n    animation:\n        smooth-progress-red 3s linear infinite,\n        roll-effect 1.5s linear infinite;\n}\n\n.progressStatusGreen {\n    background:\n        repeating-linear-gradient(45deg,\n            darkgreen,\n            darkgreen 10px,\n            #ffffff 10px,\n            #ffffff 20px);\n    animation:\n        smooth-progress-green 3s ease-in infinite,\n        roll-effect 1.5s linear infinite;\n}\n\n.progressStatusViolet {\n    background:\n        repeating-linear-gradient(45deg,\n            violet,\n            violet 10px,\n            #ffffff 10px,\n            #ffffff 20px);\n    animation:\n        smooth-progress-violet 3s ease-in infinite,\n        roll-effect 1.5s linear infinite;\n}\n\n.progressStatusCadetblue {\n    background:\n        repeating-linear-gradient(45deg,\n            cadetblue,\n            cadetblue 10px,\n            #ffffff 10px,\n            #ffffff 20px);\n    animation:\n        smooth-progress-cadetblue 3s ease-in infinite,\n        roll-effect 1.5s linear infinite;\n\n}\n\n\n.progressStatus {\n    position: relative;\n    height: 100%;\n    width: 0;\n    border-radius: 5px;\n    background-size: 200% 100%;\n}\n\n.progressStatus::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 50%;\n    height: 100%;\n    background: linear-gradient(90deg,\n            rgba(0, 0, 0, 0.8) 0%,\n            rgba(0, 0, 0, 0.4) 50%,\n            transparent 100%);\n    pointer-events: none;\n}\n\n@keyframes roll-effect {\n    0% {\n        background-position: 0 0;\n    }\n\n    100% {\n        background-position: -28px 0;\n    }\n}\n\n/* Thanh đỏ: 25% → 100% → 0% → lặp */\n@keyframes smooth-progress-red {\n    0% {\n        width: 25%;\n    }\n\n    50% {\n        width: 100%;\n    }\n\n    80% {\n        width: 0%;\n    }\n\n    100% {\n        width: 25%;\n    }\n}\n\n/* Thanh xanh lá: 75% → 100% → 0% → lặp */\n@keyframes smooth-progress-green {\n    0% {\n        width: 75%;\n    }\n\n    40% {\n        width: 100%;\n    }\n\n    70% {\n        width: 0%;\n    }\n\n    100% {\n        width: 75%;\n    }\n}\n\n/* Thanh tím: 50% → 100% → 0% → lặp */\n@keyframes smooth-progress-violet {\n    0% {\n        width: 50%;\n    }\n\n    60% {\n        width: 100%;\n    }\n\n    90% {\n        width: 0%;\n    }\n\n    100% {\n        width: 50%;\n    }\n}\n\n/* Thanh cadetblue: 0% → 100% → 0% → lặp */\n@keyframes smooth-progress-cadetblue {\n    0% {\n        width: 0%;\n    }\n\n    30% {\n        width: 100%;\n    }\n\n    60% {\n        width: 0%;\n    }\n\n    100% {\n        width: 0%;\n    }\n}\n\n/* model hiển thị dữ liệu */\n\n.modelConfirm {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.808);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.dialogContent {\n    text-align: center;\n    background-color: rgba(24, 65, 26, 0.5);\n    box-shadow: rgb(34, 217, 79) 0px 0px 10px 0px inset, rgb(34, 217, 79) 0px 0px 10px 0px;\n    max-width: 800px;\n    max-height: 600px;\n    width: 100%;\n    z-index: 2;\n    border-width: 3px;\n    border-style: solid;\n    border-color: rgb(255, 255, 255);\n    border-image: initial;\n    border-radius: 50px;\n    padding: 60px 35px 75px;\n    font-weight: bold;\n}\n\n.dialogTitle {\n    color: #fff;\n    font-size: 50px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.dialogTime {\n    background: linear-gradient(180deg, rgba(175, 232, 76, 1) 0%, rgba(54, 219, 79, 1) 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    color: transparent;\n    font-size: 40px;\n    margin-bottom: 15px;\n    font-weight: bold;\n}\n\n.dialogBullets {\n    color: #fff;\n    font-size: 24px;\n    margin-bottom: 25px;\n}\n\n.dialogCloseBtn {\n    background: #38E31B;\n    background: linear-gradient(180deg, rgba(175, 232, 76, 1) 0%, rgba(54, 219, 79, 1) 100%);\n    color: #fff;\n    font-weight: 700;\n    border: 1px solid rgb(255, 255, 255);\n    padding: 5px 50px;\n    border-radius: 30px;\n    font-size: 30px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n@media screen and (max-width: 900px) {\n    .responsiveDesktop {\n        display: none !important;\n    }\n}\n\n@media screen and (min-width: 900px) {\n    .responsiveMobile {\n        display: none !important;\n    }\n}\n\n\n.detailMobileGameInner {\n    background-image: url('https://trumcasino6789.com/images/KA_2.png');\n    height: 500px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: block;\n    margin: 0 auto;\n    border: 1px solid rgb(0, 255, 132) !important;\n    border-radius: 0 !important;\n    width: 80%;\n    max-width: 900px;\n    min-width: 300px;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n.titleMb {\n    background-image: url('https://trumcasino6789.com/images/222.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    display: grid;\n    height: 55px;\n    max-width: 100%;\n    /* width: 400px; */\n    margin: 50px auto;\n    place-content: center;\n    margin: 5% 20px 5px 20px;\n    color: #00FF84;\n    font-size: calc(0.75rem + 1vw);\n}\n\n.imgavtarMobile {\n    background-image: url('https://trumcasino6789.com/images/Vector-Smart-Object.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 110px;\n    padding: 15px 15px;\n}\n\n.imgavtarMobile>img {\n    width: 90px;\n    height: 80px;\n    border-radius: 10px;\n}\n\n/* styles.module.css */\n.ratoteTimeMb {\n    position: relative;\n}\n\n.circularContainerMb {\n    position: relative;\n    width: 150px;\n    height: 150px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.rotatingBackground {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    animation: spinMb 2s linear infinite;\n}\n\n.percentageText {\n    position: relative;\n    font-size: 22px;\n    font-weight: bold;\n    color: white;\n    z-index: 1;\n}\n\n@keyframes spinMb {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchItemGame": `style_searchItemGame__AD4bH`,
	"loadTime": `style_loadTime__Oa-L3`,
	"detailGameInner": `style_detailGameInner__dD71e`,
	"avtartTable": `style_avtartTable__P-3kn`,
	"marquee-container": `style_marquee-container__WBPrx`,
	"containerDetail": `style_containerDetail__T9oiO`,
	"imgTitleTable": `style_imgTitleTable__ueW69`,
	"marqueeContainer": `style_marqueeContainer__tre6N`,
	"marqueeContent": `style_marqueeContent__T0-rz`,
	"marquee": `style_marquee__fP-fD`,
	"timeTable": `style_timeTable__KxlqK`,
	"fontCountdown": `style_fontCountdown__sfhBz`,
	"fontStatusCountdown": `style_fontStatusCountdown__GJkCW`,
	"circularCountdown": `style_circularCountdown__LTMGu`,
	"spin": `style_spin__slbjp`,
	"btnShowTimeRound": `style_btnShowTimeRound__m2FLv`,
	"showPercentage": `style_showPercentage__NeLLp`,
	"ShowTimeRound": `style_ShowTimeRound__IcAVg`,
	"progressBar": `style_progressBar__le1KQ`,
	"progressStatusRed": `style_progressStatusRed__EaDbD`,
	"smooth-progress-red": `style_smooth-progress-red__RrLt8`,
	"roll-effect": `style_roll-effect__-EqzW`,
	"progressStatusGreen": `style_progressStatusGreen__GZtyC`,
	"smooth-progress-green": `style_smooth-progress-green__Rnm2h`,
	"progressStatusViolet": `style_progressStatusViolet__0OU2B`,
	"smooth-progress-violet": `style_smooth-progress-violet__xtIXb`,
	"progressStatusCadetblue": `style_progressStatusCadetblue__pBbU8`,
	"smooth-progress-cadetblue": `style_smooth-progress-cadetblue__M3A6k`,
	"progressStatus": `style_progressStatus__oMM+I`,
	"modelConfirm": `style_modelConfirm__orEHM`,
	"dialogContent": `style_dialogContent__fJxqV`,
	"dialogTitle": `style_dialogTitle__MzNOK`,
	"dialogTime": `style_dialogTime__8XV6f`,
	"dialogBullets": `style_dialogBullets__EUt6F`,
	"dialogCloseBtn": `style_dialogCloseBtn__g0k28`,
	"responsiveDesktop": `style_responsiveDesktop__rIkj-`,
	"responsiveMobile": `style_responsiveMobile__HQ0-w`,
	"detailMobileGameInner": `style_detailMobileGameInner__23wIo`,
	"titleMb": `style_titleMb__toeD1`,
	"imgavtarMobile": `style_imgavtarMobile__nq4yC`,
	"ratoteTimeMb": `style_ratoteTimeMb__QOkSC`,
	"circularContainerMb": `style_circularContainerMb__qDdll`,
	"rotatingBackground": `style_rotatingBackground__Bv1EJ`,
	"spinMb": `style_spinMb__Hfo-a`,
	"percentageText": `style_percentageText__lr62o`,
	"fadeIn": `style_fadeIn__MBOhU`
};
export default ___CSS_LOADER_EXPORT___;
